/* eslint-disable */
import VimeoPlayer from '@vimeo/player';
import youtubePlayer from 'youtube-player';
import lottie from 'lottie-web';


/* Lottie animations */
const lottieAnimations = () => {

    // check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        return;
    }

    // get wordpress theme path
    const themeDirectory = mfTheme.themeDirectory;
    // get the home hero motion element
    const homeHeroMotion = document.getElementById('homeHero__mediaMotion');
    // get the home intro motion element
    const homeIntroMotion = document.getElementById('homeIntro__mediaMotion');
    // get the capabilities motion element
    const capabilitiesMotion = document.getElementById('capComponent__mediaMotion');

    if (homeHeroMotion) {
        lottie.loadAnimation({
            container: homeHeroMotion,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `${themeDirectory}/public/lottie/heroAnimation.json`,
        });
    }

    if (homeIntroMotion) {
        lottie.loadAnimation({
            container: homeIntroMotion,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `${themeDirectory}/public/lottie/homepageSplit.json`,
        });
    }

    if (capabilitiesMotion) {
        lottie.loadAnimation({
            container: capabilitiesMotion,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: `${themeDirectory}/public/lottie/capabilitiesAnimation.json`,
        });
    }

};

/* Home page video */
const homeVideo = () => {

    const videoTarget = document.querySelector('.homeVideo__videoTarget');

    // If videoId doesn't exist, stop the script
    if (!videoTarget) {
        return;
    }

    const videoContainer = document.querySelector('.homeVideo__video');
    const videoPlatform = videoContainer.getAttribute('data-video-type');
    const videoId = videoContainer.getAttribute('data-video-id');

    console.log(videoPlatform, videoId);

    let player;

    if (videoPlatform === 'vimeo') {
        player = new VimeoPlayer(videoContainer, {
            id: videoId,
            autoplay: false, // Set autoplay to false
            playsinline: true,
        });
    } else if (videoPlatform === 'youtube') {
        player = youtubePlayer(videoContainer, {
            videoId: videoId,
            playerVars: {
                autoplay: 0, // Set autoplay to 0
                playsinline: 1,
            },
        });
    }

    // Play video on click
    videoTarget.addEventListener('click', () => {
        // add aria-hidden to the video target
        videoTarget.setAttribute('aria-hidden', 'true');
        if (videoPlatform === 'vimeo') {
            player.play();
        } else if (videoPlatform === 'youtube') {
            player.playVideo();
        }
    });

};

/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    homeVideo();
    lottieAnimations();

};

export default init;
